import React, { memo, SVGProps } from 'react'

export const StatusArchived = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M7.15735 14.8693C7.15735 15.6053 7.75468 16.2027 8.49068 16.2027H15.5093C16.2453 16.2027 16.8427 15.6053 16.8427 14.8693V8.26666H7.15735V14.8693ZM10.6453 9.52533H13.344C13.7813 9.52533 14.144 9.888 14.144 10.3253C14.144 10.7627 13.7813 11.1253 13.344 11.1253H10.6453C10.208 11.1253 9.84535 10.7627 9.84535 10.3253C9.84535 9.888 10.208 9.52533 10.6453 9.52533Z"
      fill="currentColor"
    />
    <path
      d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM18.592 8.26667H18.432V14.8693C18.432 16.4907 17.12 17.8027 15.4987 17.8027H8.48C6.85867 17.8027 5.54667 16.4907 5.54667 14.8693V8.26667H5.38667C4.94933 8.26667 4.58667 7.904 4.58667 7.46667C4.58667 7.02933 4.94933 6.66667 5.38667 6.66667H18.5813C19.0187 6.66667 19.3813 7.02933 19.3813 7.46667C19.3813 7.904 19.0187 8.26667 18.5813 8.26667H18.592Z"
      fill="currentColor"
    />
  </svg>
))
